/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "./CodePage.css";
import homeIcon from "../../assets/images/home.png";
import homePC from "../../assets/images/home-pc.png";
import fb from "../../assets/images/fb.png";
import telegram from "../../assets/images/telegram.png";
import ig from "../../assets/images/ig.png";
import logo from "../../assets/images/logoF168.png";
import activeImg from "../../assets/images/ActiveImg37248693812786746.jpg";

import { information } from "../../const/info.const";
const CodePage = () => {
  return (
    <HelmetProvider>
      <div className="code-page-container">
        {/* Metadata for SEO */}
        <Helmet>
          <title>Nhận Mã CODE Miễn Phí - F168</title>
          <meta
            name="description"
            content="Nhận mã CODE miễn phí từ F168 mỗi ngày. Tăng điểm thưởng và trải nghiệm các chương trình ưu đãi hấp dẫn!"
          />
          <meta
            name="keywords"
            content="F168, mã code miễn phí, nhận thưởng, tặng điểm, khuyến mãi, F168.pro"
          />
          <meta property="og:title" content="Nhận Mã CODE Miễn Phí - F168" />
          <meta
            property="og:description"
            content="Nhận mã CODE miễn phí từ F168 mỗi ngày. Tăng điểm thưởng và trải nghiệm các chương trình ưu đãi hấp dẫn!"
          />
          <meta
            property="og:image"
            content={activeImg}
          />
          <meta property="og:url" content="https://f168.pro/code" />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Nhận Mã CODE Miễn Phí - F168" />
          <meta
            name="twitter:description"
            content="Nhận mã CODE miễn phí từ F168 mỗi ngày. Tăng điểm thưởng và trải nghiệm các chương trình ưu đãi hấp dẫn!"
          />
          <meta
            name="twitter:image"
            content={activeImg}
          />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: "F168 - Nhận thưởng mã code miễn phí",
              url: "https://f168.pro",
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Trang chủ",
                  item: "https://f168.pro",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Nhận Mã CODE Miễn Phí",
                  item: "https://f168.pro/code",
                },
              ],
            })}
          </script>
        </Helmet>

        <header className="code-page-header">
          <div className="thumb-logo-code">
            <img src={logo} alt="F168" className="promo-logo" />
          </div>
          <h1 className="title">Nhận Mã CODE Miễn Phí Mỗi Ngày tại F168</h1>
          <p className="subtitle">
            Đừng bỏ lỡ cơ hội nhận mã CODE miễn phí mỗi ngày! Tham gia F168 để
            nhận ngay các phần thưởng hấp dẫn và trải nghiệm các ưu đãi độc
            quyền chỉ có tại F168.
          </p>
        </header>

        <div className="content">
          {/* Highlight Section */}
          <section className="highlight">
            <h2>Vì sao bạn nên chọn F168?</h2>
            <ul>
              <li>
                <strong>Nhận mã CODE miễn phí hàng ngày:</strong> Tham gia F168
                và nhận ngay các mã code giá trị, không giới hạn.
              </li>
              <li>
                <strong>Tham gia các chương trình ưu đãi đặc biệt:</strong> Được
                tham gia các chương trình khuyến mãi hấp dẫn với ưu đãi lớn.
              </li>
              <li>
                <strong>Hỗ trợ khách hàng 24/7:</strong> Đội ngũ hỗ trợ nhiệt
                tình và chuyên nghiệp luôn sẵn sàng hỗ trợ bạn.
              </li>
              <li>
                <strong>Đảm bảo bảo mật và uy tín:</strong> Mọi giao dịch tại
                F168 luôn được bảo mật và đáng tin cậy.
              </li>
            </ul>
          </section>
          <section className="promotion-details">
            <p>
              Mã KM:{" "}
              <span style={{ color: "#fc8b00" }}>
                <strong>CODE168</strong>
              </span>
            </p>
            <p>Thời gian hiệu lực: Đang có hiệu lực.</p>
            <p>Đơn vị tiền: 1 điểm = 1,000 VNĐ</p>
            <p>
              Gửi email đến{" "}
              <a href="mailto:admin@f168.com" target="_top">
                admin@f168.com
              </a>{" "}
              nếu bạn quên link truy cập.
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>
                <span style={{ color: "#fc8b00" }}>F168.COM</span>
              </strong>
            </p>

            <p style={{ textAlign: "justify" }}>
              Nhập CODE Đổi Thưởng là chương trình đặc biệt do F168 kết hợp với
              các nhà quảng bá lớn nhằm tạo ra sân chơi đổi thưởng đầy thú vị
              dành riêng cho thành viên tại F168.
            </p>

            <p style={{ textAlign: "justify" }}>
              <span style={{ color: "#fc8b00" }}>
                <strong>Giá trị đổi thưởng:</strong>
              </span>
            </p>

            <table
              border="1"
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <colgroup>
                <col style={{ width: "33.2888%" }} />
                <col style={{ width: "33.2888%" }} />
                <col style={{ width: "33.2888%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td
                    style={{ textAlign: "center", backgroundColor: "#fc8b00" }}
                  >
                    <span style={{ color: "#ffffff" }}>Loại CODE</span>
                  </td>
                  <td
                    style={{ textAlign: "center", backgroundColor: "#fc8b00" }}
                  >
                    <span style={{ color: "#ffffff" }}>Giá Trị</span>
                  </td>
                  <td
                    style={{ textAlign: "center", backgroundColor: "#fc8b00" }}
                  >
                    <span style={{ color: "#ffffff" }}>Vòng Cược</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Phổ Thông</td>
                  <td style={{ textAlign: "center" }}>5 ~ 388K</td>
                  <td style={{ textAlign: "center" }}>8</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Đồng</td>
                  <td style={{ textAlign: "center" }}>8 ~ 58K</td>
                  <td style={{ textAlign: "center" }}>3</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Bạc</td>
                  <td style={{ textAlign: "center" }}>59 ~ 588K</td>
                  <td style={{ textAlign: "center" }}>5</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Vàng</td>
                  <td style={{ textAlign: "center" }}>589 ~5,888K</td>
                  <td style={{ textAlign: "center" }}>8</td>
                </tr>
              </tbody>
            </table>
            <p
              style={{
                textAlign: "justify",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <a href="https://f168.pro/" target="_top">
                <span style={{ textDecoration: "underline" }}>
                  <strong>
                    <span style={{ color: "#fc8b00" }}>
                      <img alt="Đăng ký ngay"
                        src="https://igm0zw-280-ppp.oss-accelerate.aliyuncs.com/siteadmin/upload/img/1870116233704300545.gif"
                        style={{ maxWidth: "100%" }}
                      />
                    </span>
                  </strong>
                </span>
              </a>
            </p>

            <p style={{ textAlign: "justify" }}>
              <strong>
                <span style={{ color: "#fc8b00" }}>Điều kiện nhận thưởng:</span>
              </strong>
            </p>
            <p style={{ textAlign: "justify" }}>
              1. Mã CODE được tặng miễn phí qua các sự kiện, nhà phân phối, đại
              lý, kênh truyền thông... thuộc F168. Thành viên may mắn nhận được
              mã CODE, vui lòng nhập mã đổi thưởng chính xác vào trang nhập mã
              tại nút "NHẬP CODE NGAY".
            </p>
            <p style={{ textAlign: "justify" }}>
              2. Mỗi CODE chỉ có thể được nhận 01 lần, sau khi đổi thưởng thành
              công sẽ tự động hết hạn.
            </p>
            <p style={{ textAlign: "justify" }}>
              3. Một tài khoản chỉ có thể nhận được 01 CODE mỗi ngày. Mã CODE có
              thời hạn sử dụng trong vòng 05 ngày kể từ ngày được hệ thống phân
              phối, quá thời hạn sẽ không còn giá trị đổi thưởng.
            </p>
            <p style={{ textAlign: "justify" }}>
              4. Nhận được mã CODE này thành viên cần trải qua từ 3 đến 8 vòng
              cược tương ứng với loại code để rút tiền. Không áp dụng cho sản
              phẩm Xổ Số. Thành viên chưa nạp tiền được rút tối đa 5 triệu đồng.
            </p>
            <p style={{ textAlign: "justify" }}>
              5. Mỗi địa chỉ IP, thiết bị (điện thoại, máy tính bảng, PC...) chỉ
              hỗ trợ 01 tài khoản nhận thưởng.
            </p>

            <p style={{ textAlign: "justify" }}>
              <em>
                Hãy theo dõi các kênh truyền thông F168 để săn được mã CODE có
                giá trị cao nhất.
              </em>
            </p>
          </section>

          {/* Image Section */}
          <section className="image-section">
            <img
              src={activeImg}
              alt="Nhận mã CODE miễn phí tại F168"
              className="main-image"
            />
            <figcaption>Nhận mã CODE miễn phí tại F168</figcaption>
          </section>

          {/* Steps Section */}
          <section className="steps">
            <h2>Hướng dẫn nhận mã CODE miễn phí tại F168</h2>
            <ol>
              <li>
                <strong>Đăng ký tài khoản:</strong> Truy cập{" "}
                <a href="https://f168.pro">F168</a> và tạo tài khoản.
              </li>
              <li>
                <strong>Nhận mã CODE:</strong> Vào mục{" "}
                <a href="https://f168.pro/code">Nhận Mã CODE</a> và làm theo
                hướng dẫn.
              </li>
              <li>
                <strong>Sử dụng mã CODE:</strong> Dùng mã để nhận điểm thưởng
                hoặc tham gia các ưu đãi đặc biệt của F168.
              </li>
            </ol>
          </section>
        </div>
        <div className="mxh-links">
          <p className="mxh-text">
            Theo dõi để nhận thêm mã code và các ưu đãi hấp dẫn!
          </p>
          <div className="mxh-icons">
            <a href={information?.follow_tele} target="_blank" rel="noreferrer">
              <img src={telegram} alt="Telegram" className="mxh-icon" />
            </a>
            <a href={information?.follow_fb} target="_blank" rel="noreferrer">
              <img src={fb} alt="Facebook" className="mxh-icon" />
            </a>
            <a
              href={information?.follow_insta}
              target="_blank"
              rel="noreferrer"
            >
              <img src={ig} alt="Instagram" className="mxh-icon" />
            </a>
          </div>
        </div>

        <div className="cta">
          <a href="https://f168.pro" className="cta-button">
            Đăng Ký Ngay và Nhận Mã CODE Miễn Phí
          </a>
        </div>

        {/* Footer Section */}
        <footer className="code-page-footer">
          <p>
            &copy; 2024 F168. Tất cả các quyền được bảo lưu.{" "}
            <a href="https://f168.pro/sitemap.xml">Chính sách bảo mật</a> |{" "}
            <a href="https://f168.pro/code">Liên hệ</a>
          </p>
        </footer>
      </div>
    </HelmetProvider>
  );
};

export default CodePage;
